// import React, { useState, useEffect, useContext } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import { API_URL } from "../../../config";
// import { AuthContext } from "../../../Context/AuthContext";

// // ✅ All modules used in your HRM system
// const MODULES = [
//     "employees",
//     "trainees",
//     "clients",
//     "leads",
//     "projects",
//     "proposals",
//     "jobopenings",
//     "invoices",
//     "tasks",
//     "services",
//     "departments",
//     "attendance",
//     "notices",
//     "salaries",
// ];

// const PERMISSIONS = ["view", "add", "edit", "delete"];

// const UpdateUserForm = () => {
//     const { id } = useParams();
//     const navigate = useNavigate();
//     const { user } = useContext(AuthContext);

//     const [formData, setFormData] = useState({
//         name: "",
//         email: "",
//         role: "admin",
//         department: "",
//         password: "",
//         permissions: {}
//     });

//     const [loading, setLoading] = useState(true);
//     const [saving, setSaving] = useState(false);
//     const [errors, setErrors] = useState({});
//     const [generalError, setGeneralError] = useState("");

//     // Regex Patterns
//     const regex = {
//         email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
//         password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/ // Min 8 chars, 1 uppercase, 1 lowercase, 1 number, 1 special char
//     };

//     // ✅ Fetch user data
//     useEffect(() => {
//         const fetchUser = async () => {
//             try {
//                 const res = await axios.get(`${API_URL}/api/getAdminbyUsers/${id}`, {
//                     headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
//                 });

//                 const u = res.data.user;

//                 // ✅ Ensure permissions are always objects of booleans
//                 let fixedPermissions = {};
//                 Object.keys(u.permissions || {}).forEach((mod) => {
//                     fixedPermissions[mod] = {
//                         view: u.permissions[mod]?.view || false,
//                         add: u.permissions[mod]?.add || false,
//                         edit: u.permissions[mod]?.edit || false,
//                         delete: u.permissions[mod]?.delete || false,
//                     };
//                 });


//                 setFormData({
//                     name: u.name,
//                     email: u.email,
//                     role: u.role,
//                     department: u.department,
//                     password: "",
//                     permissions: fixedPermissions
//                 });

//                 setLoading(false);
//             } catch (err) {
//                 setError("Failed to load user.");
//                 setLoading(false);
//             }
//         };

//         fetchUser();
//     }, [id]);

//     // ✅ Handle simple input change
//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData({ ...formData, [name]: value });
//         setErrors(prev => ({ ...prev, [name]: "" })); // Clear error for this field
//     };

//     const validateForm = () => {
//         const newErrors = {};
//         if (!formData.name.trim()) newErrors.name = "Full Name is required.";
//         if (!formData.email.trim()) newErrors.email = "Email is required.";
//         else if (!regex.email.test(formData.email)) newErrors.email = "Invalid email format.";
//         if (formData.password && !regex.password.test(formData.password)) newErrors.password = "Password must be at least 8 characters, include uppercase, lowercase, number, and special character.";
//         if (!formData.role) newErrors.role = "Role is required.";
//         return newErrors;
//     };

//     // ✅ Toggle permission
//     const togglePermission = (module, perm) => {
//         setFormData((prev) => ({
//             ...prev,
//             permissions: {
//                 ...prev.permissions,
//                 [module]: {
//                     ...prev.permissions[module],
//                     [perm]: !prev.permissions[module][perm],
//                 },
//             },
//         }));
//     };

//     // ✅ Submit update
//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         const validationErrors = validateForm();
//         setErrors(validationErrors);

//         if (Object.keys(validationErrors).length > 0) {
//             setSaving(false);
//             return;
//         }

//         setSaving(true);
//         setGeneralError("");

//         try {
//             await axios.put(
//                 `${API_URL}/api/users/update/${id}`,
//                 formData,
//                 {
//                     headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
//                 }
//             );

//             alert("User updated successfully!");
//             navigate(-1);
//         } catch (err) {
//             console.error("Update error:", err);
//             setGeneralError(err.response?.data?.message || "Update failed.");
//             setSaving(false);
//         }
//     };

//     if (loading) return <div className="p-4">Loading user...</div>;
//     if (generalError) return <div className="alert alert-danger mt-4">{generalError}</div>;

//     return (
//         <div className="container my-4">
//             <div className="card p-4 shadow col-lg-10 mx-auto">
//                 <h3 className="mb-4 text-primary fw-bold">Update User Account</h3>

//                 <form onSubmit={handleSubmit}>
//                     {/* Basic Fields */}
//                     <div className="row g-4 mb-3">
//                         <div className="col-md-6">
//                             <label className="form-label">Full Name</label>
//                             <input
//                                 name="name"
//                                 className={`form-control ${errors.name ? "is-invalid" : ""}`}
//                                 value={formData.name}
//                                 onChange={handleChange}
//                                 required
//                             />
//                             {errors.name && <div className="invalid-feedback">{errors.name}</div>}
//                         </div>

//                         <div className="col-md-6">
//                             <label className="form-label">Email</label>
//                             <input
//                                 name="email"
//                                 className={`form-control ${errors.email ? "is-invalid" : ""}`}
//                                 value={formData.email}
//                                 onChange={handleChange}
//                                 required
//                             />
//                             {errors.email && <div className="invalid-feedback">{errors.email}</div>}
//                         </div>

//                         <div className="col-md-6">
//                             <label className="form-label">Role</label>
//                             <select
//                                 name="role"
//                                 value={formData.role}
//                                 onChange={handleChange}
//                                 className={`form-select ${errors.role ? "is-invalid" : ""}`}
//                             >
//                                 <option value="">Select Role</option>
//                                 <option value="admin">Admin</option>
//                                 <option value="superadmin">Superadmin</option>
//                                 <option value="hr">HR</option>
//                                 <option value="accountant">Accountant</option>
//                                 <option value="manager">Manager</option>
//                             </select>
//                         </div>

//                         <div className="col-md-6">
//                             <label className="form-label">New Password</label>
//                             <input
//                                 name="password"
//                                 type="password"
//                                 className={`form-control ${errors.password ? "is-invalid" : ""}`}
//                                 placeholder="Leave empty to keep old password"
//                                 value={formData.password}
//                                 onChange={handleChange}
//                             />
//                             {errors.password && <div className="invalid-feedback">{errors.password}</div>}
//                         </div>
//                     </div>

//                     {/* Permissions Table */}
//                     <h5 className="fw-bold mb-3">Module Permissions</h5>

//                     <div className="table-responsive">
//                         <table className="table table-bordered text-center align-middle">
//                             <thead className="table-light">
//                                 <tr>
//                                     <th>Module</th>
//                                     {PERMISSIONS.map((p) => (
//                                         <th key={p}>{p.toUpperCase()}</th>
//                                     ))}
//                                 </tr>
//                             </thead>

//                             <tbody>
//                                 {Object.keys(formData.permissions).map((mod) => (
//                                     <tr key={mod}>
//                                         <td className="fw-semibold text-capitalize">{mod}</td>

//                                         {PERMISSIONS.map((perm) => (
//                                             <td key={perm}>
//                                                 <input
//                                                     type="checkbox"
//                                                     checked={formData.permissions[mod]?.[perm] || false}
//                                                     onChange={() =>
//                                                         togglePermission(mod, perm)
//                                                     }
//                                                 />
//                                             </td>
//                                         ))}
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>

//                     {/* Buttons */}
//                     <div className="d-flex justify-content-end gap-3 mt-3">
//                         <button
//                             type="button"
//                             className="btn btn-secondary"
//                             onClick={() => navigate(-1)}
//                             disabled={saving}
//                         >
//                             Cancel
//                         </button>

//                         <button
//                             type="submit"
//                             className="btn btn-primary"
//                             disabled={saving}
//                         >
//                             {saving ? "Updating..." : "Update User"}
//                         </button>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// };

// export default UpdateUserForm;

import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../../config";
import { AuthContext } from "../../../Context/AuthContext";

const PERMISSIONS = ["view", "add", "edit", "delete"];
const ACTION_INDEX_MAP = {
  0: "view",
  1: "add",
  2: "edit",
  3: "delete",
};

const UpdateUserForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    role: "admin",
    department: "",
    password: "",
    permissions: {},
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({});
  const [generalError, setGeneralError] = useState("");

  const regex = {
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    password:
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).{8,}$/,
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axios.get(
          `${API_URL}/api/getAdminbyUsers/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        const u = res.data.user;

        const fixedPermissions = {};
        Object.keys(u.permissions || {}).forEach((mod) => {
          const raw = u.permissions[mod];
          const normalized = {
            view: false,
            add: false,
            edit: false,
            delete: false,
          };

          if (Array.isArray(raw)) {
            raw.forEach((item) => {
              const mapped = ACTION_INDEX_MAP[String(item).toLowerCase()] || String(item).toLowerCase();
              if (PERMISSIONS.includes(mapped)) normalized[mapped] = true;
            });
          } else if (raw && typeof raw === "object") {
            PERMISSIONS.forEach((perm) => {
              normalized[perm] = raw[perm] === true;
            });
          }

          fixedPermissions[mod] = normalized;
        });

        setFormData({
          name: u.name || "",
          email: u.email || "",
          role: u.role || "admin",
          department: u.department || "",
          password: "",
          permissions: fixedPermissions,
        });

        setLoading(false);
      } catch (err) {
        setGeneralError("Failed to load user.");
        setLoading(false);
      }
    };

    fetchUser();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim())
      newErrors.name = "Full Name is required.";

    if (!formData.email.trim())
      newErrors.email = "Email is required.";
    else if (!regex.email.test(formData.email))
      newErrors.email = "Invalid email format.";

    if (formData.password && !regex.password.test(formData.password))
      newErrors.password =
        "Password must include uppercase, lowercase, number, and special character.";

    if (!formData.role)
      newErrors.role = "Role is required.";

    return newErrors;
  };

  const togglePermission = (module, perm) => {
    setFormData((prev) => ({
      ...prev,
      permissions: {
        ...prev.permissions,
        [module]: {
          ...prev.permissions[module],
          [perm]: !prev.permissions[module]?.[perm],
        },
      },
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0)
      return;

    setSaving(true);
    setGeneralError("");

    try {
      await axios.put(
        `${API_URL}/api/users/update/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      alert("User updated successfully!");
      navigate(-1);
    } catch (err) {
      setGeneralError(
        err.response?.data?.message || "Update failed."
      );
      setSaving(false);
    }
  };

  if (loading) return <div className="p-4">Loading user...</div>;
  if (generalError)
    return (
      <div className="alert alert-danger mt-4">
        {generalError}
      </div>
    );

  return (
    <div className="container my-4">
      <div className="card p-4 shadow col-lg-10 mx-auto">
        <h3 className="mb-4 fw-bold" style={{ color: "#003e6d" }}>
          Update User Account
        </h3>

        <form onSubmit={handleSubmit}>
          <div className="row g-4 mb-3">
            <div className="col-md-6">
              <label>Full Name</label>
              <input
                name="name"
                className={`form-control ${
                  errors.name ? "is-invalid" : ""
                }`}
                value={formData.name}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6">
              <label>Email</label>
              <input
                name="email"
                className={`form-control ${
                  errors.email ? "is-invalid" : ""
                }`}
                value={formData.email}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="d-flex justify-content-end mt-3">
            <button
              type="submit"
              className="btn"
              style={{
                background: "linear-gradient(105deg, #c9d9ea, #c0d2e4 60%, #b5c9de)",
                color: "#003e6d",
                border: "1px solid #a9c3dd",
              }}
              disabled={saving}
            >
              {saving ? "Updating..." : "Update User"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateUserForm;
